import * as XLSX from "xlsx";
import moment from "moment";
import { PhoneNumber } from "../../utils/phoneNumber";


const applicantsExcelReport = async (aplicants: any) => {
    if (aplicants.length === 0 || !aplicants) return

    const headers = [
        "Apellido",
        "Nombre",
        "DNI-PASAPORTE",
        "CUIL",
        "Nacionalidad",
        "Fecha de nacimiento",
        "Estado Civil",
        "Sexo",
        "Género",
        "Email",
        "Teléfono",       
        "Puesto",
        "Fecha de creación del postulante"
    ];

    const excelDataPromises = aplicants?.map((applicant: any) => {
        const lastname = applicant?.name?.split(',')[0]?.toUpperCase();
        const name = applicant?.name?.split(',')[1]?.toUpperCase();
        const dni = applicant?.DNI ? applicant?.DNI : '---';
        const cuil = applicant?.cuil ? applicant?.cuil : '---';
        const nacionalidad = applicant?.nationality ? applicant?.nationality?.toUpperCase() : '---';
        const fechaNacimiento = applicant?.birthDate;
        const estadoCivil = applicant?.maritalStatus ? applicant?.maritalStatus?.toUpperCase() : '---';
        const sexo = applicant?.sex ? applicant?.sex : '---';
        const genero = applicant?.gender ? applicant?.gender : '---';
        const email = applicant?.email ? applicant?.email : '---';
        const tel = applicant?.phoneNumber ? PhoneNumber(applicant?.phoneNumber) : '---';       
        const posicion = applicant?.positionName ? applicant?.positionName?.toUpperCase() : '---';
        const fechaCreacionPostulante = moment(applicant?.createdDate).format('DD/MM/YYYY')



        return [
            lastname,
            name,
            dni,
            cuil,
            nacionalidad,
            fechaNacimiento,
            estadoCivil,
            sexo,
            genero,
            email,
            tel,           
            posicion,
            fechaCreacionPostulante,
        ]
    })



    const excelData = await Promise.all(excelDataPromises);
    const ws = XLSX.utils.aoa_to_sheet([headers, ...excelData]);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const date = moment().format('DD/MM/YYYY')
    let filename = `Reportes-todos-Postulantes-${date}.xlsx`;

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.click();

    return excelDataPromises;

}
export default applicantsExcelReport;